// This file contains a mapping of constants to parts of file names
// in order to make it easier to maintain the correct loading of the watch components
// Also includes the default colors for the components

import { Color } from './colors'
import { Material, MATERIALS_ORDER } from './materials'

const BAND_PART = 'Band'
const GEHAUESE_PART = 'ExoGehaeuse'
const KRONE_PART = 'Krone'
const NAHT_PART = 'Naht'
const SEKRING_PART = 'SekRing'
const SEKZEIGER_PART = 'SekZeiger'
const ZIFFERBLATT_PART = 'Zifferblatt'
const ROTORWABEN_PART = 'RotorWaben'
const SCHRAUBEN_PART = 'Schrauben'
const WERKHALTERRING_PART = 'Werkhaltering'




// Default colors and materials
export interface ColorMaterialInformation {
  color: Color;
  material: Material;
}

const ALL_FRONT_PARTS: {[key: string]: ColorMaterialInformation} =  {
    [BAND_PART]: { color: Color.SCHWARZ, material: Material.NONE_MATERIAL},
    [GEHAUESE_PART]: { color: Color.TITAN, material: Material.NONE_MATERIAL},
    [KRONE_PART]: { color: Color.TITAN, material: Material.NONE_MATERIAL},
    [NAHT_PART]: { color: Color.SCHWARZ, material: Material.NONE_MATERIAL},

    [SEKRING_PART]: { color: Color.TITAN, material: Material.NONE_MATERIAL},
    [SEKZEIGER_PART]: { color: Color.SMARAGDGRUEN, material: Material.NONE_MATERIAL},
    [ZIFFERBLATT_PART]: { color: Color.TITAN, material: Material.BRUSHED_MATERIAL},
}

const ALL_BACK_PARTS: {[key: string]: ColorMaterialInformation} = {
    [BAND_PART]: { color: Color.SCHWARZ, material: Material.NONE_MATERIAL},
    [GEHAUESE_PART]: { color: Color.TITAN, material: Material.NONE_MATERIAL},
    [KRONE_PART]: { color: Color.TITAN, material: Material.NONE_MATERIAL},
    [NAHT_PART]: { color: Color.SCHWARZ, material: Material.NONE_MATERIAL},

    [ROTORWABEN_PART]: { color: Color.TITAN, material: Material.NONE_MATERIAL},
    [SCHRAUBEN_PART]: { color: Color.TITAN, material: Material.NONE_MATERIAL},
    [WERKHALTERRING_PART]: { color: Color.TITAN, material: Material.NONE_MATERIAL},
}

function isFrontPart(componentName: string): boolean {
  return Object.keys(ALL_FRONT_PARTS).includes(componentName)
}

function isBackPart(componentName: string) {
  return !isFrontPart(componentName)
}

function getDefaultMaterialForComponent(componentName: string): Material {
  return isFrontPart(componentName)? ALL_FRONT_PARTS[componentName].material : ALL_BACK_PARTS[componentName].material
}

// This is needed for the ShareLinkBuilder to always have the correct order when serializing and deserializing shared links
const PARTS_ORDER = [BAND_PART,
GEHAUESE_PART,
KRONE_PART,
NAHT_PART,
SEKRING_PART,
SEKZEIGER_PART,
ZIFFERBLATT_PART,
ROTORWABEN_PART,
SCHRAUBEN_PART,
WERKHALTERRING_PART]

export default { 
    BAND_PART,
    GEHAUESE_PART,
    KRONE_PART,
    NAHT_PART,
    SEKRING_PART,
    SEKZEIGER_PART,
    ZIFFERBLATT_PART,
    ROTORWABEN_PART,
    SCHRAUBEN_PART,
    WERKHALTERRING_PART,
    ALL_FRONT_PARTS,
    ALL_BACK_PARTS,
    PARTS_ORDER,
    MATERIALS_ORDER,
    isFrontPart,
    isBackPart,
    getDefaultMaterialForComponent
}